module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA4AQMAAACWvXlgAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAABZJREFUGNNj+A8BBxgoZAw2MOovvAwAk+65WRm6WloAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/mCom/nav_down_icon.png
// module id = bUAH
// module chunks = 27